import React, { useEffect, useState } from "react";
import { Row, Col, Divider } from "antd";
import PreviewComponent from "@/components/preview/PreviewComponent";
import { sessionsRecordings } from "@/services/users/sessionsRecordings";

const StudentVideos = ({ student, onClose }) => {
  const [sessions, setSessions] = useState([]);

  const fetchSessions = async () => {
    await sessionsRecordings(student?.id)
      .then((res) => {
        setSessions(res?.rows || []);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    if (student?.id) {
      fetchSessions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [student]);

  return (
    <div>
      {/* <div className="header">
        <div className="student-info">
          <div className="content-back-button">
            <IconBackArrow onClick={onClose} />
          </div>
          <div className="profile-picture">
            <img src={student?.profileImgUrl} alt="" />
          </div>
          <div className="body-b1">
            {student?.firstName} {student?.lastName}
          </div>
        </div>
      </div> */}
      <div className="save-video-container">
        {sessions?.map((data, i) => {
          return (
            <div style={{ marginBottom: "20px" }} key={i}>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <div className="title-h6-1">{data?.name}</div>
                <div className="flex-1">
                  <Divider />
                </div>
              </div>
              <Row gutter={[16, 24]}>
                {data?.sessions?.map((session, index) => (
                  <Col key={index} xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <div className="video-section">
                      <PreviewComponent
                        img_url={
                          session?.img_url ? session?.img_url : "/assets/images/video_img.png"
                        }
                        url={session?.sessionRecordedUrl}
                        type="video"
                      />
                      <div className="video-label">
                        <label>
                          Date-Time: {session?.date} {session?.time}
                        </label>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StudentVideos;
